import {
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS,
    RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE,
    FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST,
    DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST,
    UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST,
    FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_REQUEST,
    CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_FAILURE,
    CREATE_STYLE_IN_PROGRESS_REQUEST,
    CREATE_STYLE_IN_PROGRESS_SUCCESS,
    CREATE_STYLE_IN_PROGRESS_FAILURE
} from './processAssignStyleMaster.actionsType';

export const PROCESS_ASSIGN_STYLE_MASTER = 'processAssignStyleMaster';

let initialState = {
    loading: false,
    processAssignStyleMasterList: [],
    processAssignStyleMasterForm: {},
    selectedState: {},
    errorMessage: ''
};

export let processAssignStyleMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST:
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_REQUEST:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST:
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST:
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_REQUEST:
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_REQUEST:
        case CREATE_STYLE_IN_PROGRESS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterList: updatePayload
            };
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {},
                assignProcessStatus: updatePayload
            };
        case CREATE_STYLE_IN_PROGRESS_SUCCESS:
            return {
                loading: false,
                ...state,
                styleInProgress: updatePayload

            }
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {}
            };
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: updatePayload
            };
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {}
            };
        case RESET_PROCESS_ASSIGN_STYLE_MASTER_INFO:
            return {
                ...state,
                processAssignStyleMasterForm: {}
            };
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_FORM:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FORM:
            return {
                ...state,
                loading: false,
                processAssignStyleMasterForm: {
                    ...state.processAssignStyleMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_ASSIGN_STYLE_MASTER_FAILURE:
        case UPDATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE:
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE:
        case FETCH_SINGLE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE:
        case DELETE_PROCESS_ASSIGN_STYLE_MASTER_FAILURE:
        case CREATE_PROCESS_ASSIGN_STYLE_MASTER_COSTKG_PROCESS_FAILURE:
        case CREATE_STYLE_IN_PROGRESS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
